import React, {useEffect, useState} from 'react';
import moment from "moment/moment";
import {useController, useForm} from "react-hook-form";
import axios from "../../../../helpers/axios";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import CustomDatePicker from "../../../base/components/forms/customDatePicker";
import LoadingButton from "../../../base/components/loadingButton";
import {Table} from "reactstrap";
import numberFormat from "../../../../helpers/numberFormat";
import BlockUi from "@availity/block-ui";
import _ from "lodash";
import {Link} from "react-router-dom";
import SearchSelect from "../../../../components/searchSelect";

const PaymentGroupRow = ({payment}) => {
  const [open, setOpen] = useState(false)
  return <>
    <tr className={'pointer'}
        onClick={() => setOpen(!open)}
        style={{backgroundColor: open ? '#e8f0fe' : 'white'}}>
      <td style={{width: '2rem'}}>
        <i className={`fa fa-chevron-${open ? 'up' : 'down'}`}/>
      </td>
      <td>{payment.paymentId}</td>
      <td>{payment.paidAt}</td>
      <td>{payment.paidBy}</td>
      <td>
        {(payment.paidTo || []).map(name => <div key={name}>{name}</div>)}
      </td>
      <td>{payment.count}</td>
      <td>{numberFormat(payment.reward)}</td>
    </tr>
    {open && <tr>
      <td colSpan={7} style={{padding: 0, backgroundColor: '#f7f8fa'}}>
        <Table bordered size={'sm'} className={'mb-0'} style={{backgroundColor: 'white'}}>
          <thead>
          <tr>
            <th>Подвязка</th>
            <th>Сумма</th>
            <th>Выписал</th>
            <th>Комментарий</th>
          </tr>
          </thead>
          <tbody>
          {payment.tickets.map(item => (
            <tr key={item.id}>
              <td style={{textWrap: 'nowrap'}}>
                <Link to={item.baseLink + '/' + item.bookingId} target={'_blank'}>
                  {item.ticketNumber}
                </Link>
              </td>
              <td>{numberFormat(item.reward)}</td>
              <td>{item.issuedBy}</td>
              <td>{item.comment}</td>
            </tr>
          ))}
          </tbody>
        </Table>
      </td>
    </tr>}
  </>
}

const TiedUpPaymentsInfo = () => {
  const [loading, setLoading] = useState(false)
  const [payments, setPayments] = useState()
  const [emplArray, setEmplArray] = useState()
  const defaultVal = {
    start: moment().subtract(3, 'months').format('DD.MM.YYYY'),
    end: moment().format('DD.MM.YYYY'),
    issuedBy: null
  }
  const formController = useForm(defaultVal)
  const {control, handleSubmit} = formController
  const {
    field: {onChange: issuedByOnChange, value: issuedByValue}
  } = useController({
    name: "issuedBy",
    control,
    defaultValue: null
  });

  const onSubmit = (values) => {
    const query = _.omitBy(values, _.isNil)
    setLoading(true)
    axios.post('/api/air/airBooking/tiedUpTickets/paidList', {query})
      .then(({data}) => setPayments(data.payments || []))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    axios.post('/api/users/emplSearch', {operatorOneS: true})
      .then(({data}) => {
        const newArr = data.data.map(user => ({
          label: user.label,
          value: user.value._id
        }))
        setEmplArray([{label: "Все", value: null}, ...newArr])
      })
  }, []);

  return (
    <BlockUi blocking={loading}>
      <Portlet className={'mb-1'}>
        <PortletHeader title={'Инфо по оплатам'} toolbar={<PortletHeaderToolbar>
          <form onSubmit={handleSubmit(onSubmit)} className={'d-flex align-items-center gap-2'}>
            <CustomDatePicker formController={formController}
                              label={"Оплата с"}
                              value={defaultVal.start}
                              name={`start`}
                              rules={{required: true}}/>
            <CustomDatePicker formController={formController}
                              label={"Оплата по"}
                              value={defaultVal.end}
                              name={`end`}
                              rules={{required: true}}/>
            {emplArray && <SearchSelect
              style={{width: "12rem"}}
              onChange={issuedByOnChange}
              defaultValue={issuedByValue}
              label={'Выписал'}
              array={emplArray}/>}
            <LoadingButton loading={loading} title={'Получить'}/>
          </form>
        </PortletHeaderToolbar>}/>
      </Portlet>
      {payments && <Portlet>
        <PortletBody>
          <Table bordered size={'sm'}>
            <thead>
            <tr>
              <th></th>
              <th>Номер оплаты</th>
              <th>Когда</th>
              <th>Оплатил</th>
              <th>Кому оплачено</th>
              <th>Подвязок</th>
              <th>Сумма</th>
            </tr>
            </thead>
            <tbody>
            {!payments.length && <tr>
              <td colSpan={7}>Нет оплат за выбранный период</td>
            </tr>}
            {payments.map(payment => (
              <PaymentGroupRow key={payment.id} payment={payment}/>
            ))}
            <tr>
              <th colSpan={5}>Итого</th>
              <th>{_.sumBy(payments, 'count')}</th>
              <th>{numberFormat(_.sumBy(payments, 'reward'))}</th>
            </tr>
            </tbody>
          </Table>
        </PortletBody>
      </Portlet>}
    </BlockUi>
  );
};

export default TiedUpPaymentsInfo;
